import { createSlice } from '@reduxjs/toolkit';

const savedTheme = localStorage.getItem('theme') || 'dark';

const initialState = {
  theme: savedTheme,
  isSidebarOpen: false,
  isSearchOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme', state.theme);
      document.body.classList.toggle('light-theme', state.theme === 'light');
      document.body.style.background = '';
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
      localStorage.setItem('theme', state.theme);
      document.body.classList.toggle('light-theme', state.theme === 'light');
      document.body.style.background = '';
    },
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    closeSidebar: (state) => {
      state.isSidebarOpen = false;
    },
    toggleSearch: (state) => {
      state.isSearchOpen = !state.isSearchOpen;
    },
    closeSearch: (state) => {
      state.isSearchOpen = false;
    },
  },
});

export const {
  toggleTheme,
  setTheme,
  toggleSidebar,
  closeSidebar,
  toggleSearch,
  closeSearch
} = uiSlice.actions;

export default uiSlice.reducer;
